// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"6a65409b","209":"0141bed1","550":"4f03d18d","569":"3ea10d14","577":"5ba69d85","652":"acffbdf5","711":"e7ad7a98","822":"ab907b7e","849":"5708d775"}[chunkId] + ".chunk.js";
};